<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <p :class="cn('text-sm text-muted-fg', props.class)">
    <slot />
  </p>
</template>
